import { Database } from "@/integrations/supabase/types";

export type ScreenType = Database["public"]["Enums"]["screen_type"];

export enum AccessProfileSlug {
  Admin = "admin",
  Membro = "membro",
  AdminAgencia = "admin_agencia",
  MembroAgencia = "membro_agencia",
}

export interface UserProfile {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  allowed_screens: ScreenType[];
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserWithProfile {
  id: string;
  email: string | null;
  full_name: string | null;
  username: string | null;
  avatar_url: string | null;
  evaluation_weight: number | null;
  access_profile_id: number | null;
  access_profile_name: string | null;
  access_profile_slug: string | null;
  access_profile_description: string | null;
  access_profile_screens: ScreenType[] | null;
  access_profile_is_active: boolean | null;
  profile_assigned_at: string | null;
  agencia_id: string | null;
  agencia_nome: string | null;
}

// Screen labels for display
export const screenLabels: Record<ScreenType, string> = {
  dashboard: "Dashboard",
  freelancers: "Freelancers",
  vagas: "Vagas",
  projetos: "Projetos",
  agencias: "Agências",
  avaliacoes_pos_projeto: "Avaliações Por Projeto",
  avaliacoes_perfil_freelancer: "Avaliações Perfil Freelancer",
  formularios_avaliacao: "Formulários de Avaliação",
  configuracoes: "Configurações",
  gestao_perfis_usuarios: "Gestão de Perfis e Usuários",
  // Módulo de Agents
  agents_chat: "Chat Assistente",
  agents_match: "Match Inteligente",
  agents_portfolios: "Análise de Portfolios",
  agents_monitoring: "Monitoramento",
  // Atividades
  atividades: "Atividades",
  // Campanhas
  campanhas: "Campanhas",
  // Agência
  dashboard_agencia: "Dashboard Agência",
  avaliacoes_agencia: "Avaliações Agência",
  gestao_usuarios_agencia: "Gestão Usuários Agência",
  // Mesclagem
  mesclar_freelancers: "Mesclar Freelancers",
  // LinkedIn + empresas
  linkedin: "LinkedIn (Upload de PDFs)",
  empresas: "Empresas",
  // Admin de pesos da recomendação (R9)
  recomendacao_pesos: "Pesos da Recomendação",
  completude_dados: "Completude de Dados",
  // Radar de Perfis (indicação manual por agência)
  radar_agencias: "Radar de Perfis",
  // Atualizações do WhatsApp (Speeke)
  atualizacoes_whatsapp: "Atualizações do WhatsApp",
  // Financeiro (Omie: cadastros, propostas, OS)
  financeiro: "Financeiro",
  financeiro_os: "Financeiro - OS",
  // Telas da versão nova
  hoje: "Hoje",
  contatos: "Contatos",
  revisoes: "Revisões",
  // Painéis
  paineis: "Painéis",
  // Relatórios
  relatorios: "Relatórios",
  // Plataforma (super admin)
  super_admin: "Plataforma",
};

// All available screens
export const allScreens: ScreenType[] = [
  "dashboard",
  "freelancers",
  "vagas",
  "projetos",
  "agencias",
  "avaliacoes_pos_projeto",
  "avaliacoes_perfil_freelancer",
  "formularios_avaliacao",
  "configuracoes",
  "gestao_perfis_usuarios",
  // Módulo de Agents
  "agents_chat",
  "agents_match",
  "agents_portfolios",
  "agents_monitoring",
  // Atividades
  "atividades",
  // Campanhas
  "campanhas",
  // Agência
  "dashboard_agencia",
  "avaliacoes_agencia",
  "gestao_usuarios_agencia",
  // Mesclagem
  "mesclar_freelancers",
  // LinkedIn + empresas
  "linkedin",
  "empresas",
  // Admin de pesos da recomendação
  "recomendacao_pesos",
  "completude_dados",
  // Radar de Perfis
  "radar_agencias",
  // Atualizações do WhatsApp
  "atualizacoes_whatsapp",
  // Financeiro
  "financeiro",
  "financeiro_os",
  // Telas da versão nova
  "hoje",
  "contatos",
  "revisoes",
];

